<template>
  <NewPaymentsPayoneerEditAdmin
          :NPP="NPP"
          :serverError="serverError"
          @updatePayment="updatePayment"
          @pay="pay"
  />
</template>

<script>
  import NewPaymentsPayoneerEditAdmin from "./NewPaymentsPayoneerEditAdmin/NewPaymentsPayoneerEditAdmin";
  import {NewPaymentsPayoneer} from "../../models/NewPaymentsPayoneer";
  import {checkAccess} from "@/mixins/userCredentionalMixins/userCredentional";
  // import {NEW_PAYMENTS_PAYONEER_STATUSES} from "../../../../../staticData/staticVariables";
  import {newPaymentsPayoneerMixin} from "@/mixins/newPaymentsPayoneerMixins/newPaymentsPayoneerMixin";

  export default {
    name: "NewPaymentsPayoneerEdit",

    components: {
      NewPaymentsPayoneerEditAdmin,
    },

    mixins: [newPaymentsPayoneerMixin, checkAccess],

    data() {
      return {
        NPP: new NewPaymentsPayoneer(),
        serverError: false,
      }
    },

    mounted() {
      this.$store.dispatch('getNewPaymentsPayoneer', this.$route.params.id).then(() => {
        this.NPP.setNewPaymentPayoneerItem(this.$store.getters.getNewPaymentsPayoneerItem)
      }).catch(error => this.createErrorLog(error))
    },

    methods: {

      pay() {
        this.newPaymentPayoneerAccess(this.NPP.newPayments.id).then(response => {
          if(response){
            this.payPaymentPayoneer(this.NPP.newPayments.id, {goToTable: true})
          }
        })
      },

      updatePayment() {
        if(!this.NPP.newPaymentsPayoneerValidate()) return

        let data = this.NPP.newPaymentsPayoneerPrepare()

        let updateRequestType = 'updateNewPaymentsPayoneer'
        // if (this.NPP.newPayments.status === NEW_PAYMENTS_PAYONEER_STATUSES.COMPLETE) {
        //   updateRequestType = 'updateCommentNewPaymentsPayoneer'
        // }

        this.$store.dispatch(updateRequestType, {data: data, id: this.NPP.newPayments.id}).then((response) => {
          if (this._.has(response, 'data') &&
            response.data.status === this.$store.getters.GET_ERRORS.SUCCESS_CODE) {

            this.openNotify('success', 'common_notificationRecordChanged')
            this.$router.push(this.$store.getters.GET_PATHS.financeNewPaymentsPayoneer)

          } else if (response.response.data.status === this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE) {
            alert('VALIDATION_ERROR')
          } else {
            this.openNotify('error', 'common_notificationUndefinedError')
          }
        })
      },
    },

  }
</script>

<style scoped>

</style>
